import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cls from "./SuspendedUsers.module.scss";
import api from "@/utils/axios";
import { timeAgo } from "@/utils/timeAgo";

const SuspendedUsers = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({
    totalPages: 1,
    hasNextPage: false,
    hasPrevPage: false,
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetchUsers = async (p = 1) => {
    try {
      setLoading(true);

      const res = await api.get(
        `/v1/admin/members/suspended-users?page=${p}&limit=50`
      );

      setUsers(res.data.data || []);
      setMeta({
        totalPages: res.data.totalPages,
        hasNextPage: res.data.hasNextPage,
        hasPrevPage: res.data.hasPrevPage,
        total: res.data.total,
      });
      setPage(res.data.page);
    } catch (err) {
      console.error("Error loading suspended users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  return (
    <div className={cls.container}>
      <div className={cls.headerRow}>
        <button
          type="button"
          className={cls.backBtn}
          onClick={() => navigate("/admin/members")}
        >
          ← Back to Members
        </button>

        <div className={cls.titleBlock}>
          <h2 className={cls.title}>Suspended Users</h2>
          <p className={cls.subtitle}>
            These accounts have been <strong>temporarily disabled</strong> for
            violating rules or admin review.
          </p>
        </div>
      </div>

      <div className={cls.metaBar}>
        <span className={cls.chip}>
          Total Suspended: <strong>{meta.total}</strong>
        </span>
        <span className={cls.chipSoft}>
          Page {page} / {meta.totalPages || 1}
        </span>
      </div>

      {loading ? (
        <div className={cls.loading}>
          <span className={cls.spinner} />
          <span>Loading suspended users...</span>
        </div>
      ) : users.length === 0 ? (
        <div className={cls.empty}>
          <p>No suspended users at the moment ✨</p>
          <p className={cls.emptySub}>
            Your community is clean — no violations detected.
          </p>
        </div>
      ) : (
        <>
          <div className={cls.tableWrap}>
            <table className={cls.table}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Joined</th>
                  <th className={cls.actionsCol}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {users.map((u, index) => (
                  <tr key={u.id}>
                    <td>{(page - 1) * 50 + index + 1}</td>

                    <td className={cls.usernameCell}>
                      <span className={cls.username}>@{u.username}</span>
                    </td>

                    <td className={cls.emailCell}>{u.email}</td>

                    <td className={cls.roleCell}>
                      <span className={cls.roleBadge}>{u.role}</span>
                    </td>

                    <td className={cls.dateCell}>{timeAgo(u.joinedAt)}</td>

                    <td className={cls.actionsCell}>
                      <button
                        type="button"
                        className={cls.viewBtn}
                        onClick={() =>
                          navigate(`/admin/members/single/${u.id}`)
                        }
                      >
                        View Profile →
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={cls.pagination}>
            <button
              type="button"
              disabled={!meta.hasPrevPage || loading}
              onClick={() => fetchUsers(page - 1)}
            >
              ← Prev
            </button>

            <span>
              Page {page} / {meta.totalPages || 1}
            </span>

            <button
              type="button"
              disabled={!meta.hasNextPage || loading}
              onClick={() => fetchUsers(page + 1)}
            >
              Next →
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SuspendedUsers;
